
import XHeader from 'vux/src/components/x-header/index.vue'

import { isGoLogin } from '../util'
export default {
name: 'PageHeader',
components: {
XHeader
},
data () {
return {
backTopFlag: false
}
},
methods: {
widOnSrool: function () {
let top = document.body.scrollTop | document.documentElement.scrollTop
const path = this.$route.path
if (top > 220 && path !== '/chat') {
this.backTopFlag = true
} else {
this.backTopFlag = false
}
},
backTop: function () {
window.scrollTo(0, 0)
},
goChat: function () {
if (isGoLogin(this)) {
window.open('http://p.qiao.baidu.com/cps/chat?siteId=12052193&userId=25589247')
}
}
},
created () {


document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
},
mounted () {
window.onscroll = this.widOnSrool
}
}



// WEBPACK FOOTER //
// ./src/components/header.vue